export const labelTooltipArchivio = "Archivio";
export const labelTooltipDoc = "Doc";
export const labelTooltipPdf = "Pdf";
export const labelTooltipProgetti = "Progetti";
export const labelTooltipReports = "Segnalazioni";
export const labelTooltipSettings = "Impostazioni";
export const labelTooltipTopic = "Classificazione";
export const labelTooltipTxt = "Txt";
export const labelTooltipUsers = "Utenti";
